import { render } from "./HomeView.vue?vue&type=template&id=23d24ef8&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jenacawillans/Documents/DeveloperCode/vue/jenaca-dev-website/jenaca-dev-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__